import { render, staticRenderFns } from "./SpecialOrExtraordinaryExpenses.vue?vue&type=template&id=5788f3e7"
import script from "./SpecialOrExtraordinaryExpenses.vue?vue&type=script&lang=js"
export * from "./SpecialOrExtraordinaryExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports